var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-checkbox',{attrs:{"switch":""},model:{value:(_vm.sourceCodeMode),callback:function ($$v) {_vm.sourceCodeMode=$$v},expression:"sourceCodeMode"}})}
var staticRenderFns = []

export { render, staticRenderFns }